export default __webpack_public_path__ + "static/media/Gauntlets of the Invincible.25646726.jpg";